<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M6.62102 18H2.96804L2.96804 10.125H0V6.86739H2.96804V4.38456C2.96804 1.56013 4.71317 0 7.3833 0C8.66225 0 10 0.220105 10 0.220105V2.99347H8.52595C7.07387 2.99347 6.62102 3.86217 6.62102 4.75345V6.86739H9.863L9.3448 10.125H6.62102V18Z"
		fill="white"
		fill-opacity="1"
	/>
</svg>
